module.exports = __webpack_public_path__ + "media/images/members/luis_iglesias_feijoo-02e0ee39b5556c9a60aebcc2ba57742f.jpg";